import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.StoreServiceProxy,
        ApiServiceProxies.ProductStoreServiceProxy,
        ApiServiceProxies.ProductStorePublicServiceProxy,
        ApiServiceProxies.ProvinceServiceProxy,
        ApiServiceProxies.OrderServiceProxy,
        ApiServiceProxies.PersonServiceProxy,
        ApiServiceProxies.OrderPublicServiceProxy,
        ApiServiceProxies.OrderDetailServiceProxy,
        ApiServiceProxies.TransactionServiceProxy,
        ApiServiceProxies.CartServiceProxy,
        ApiServiceProxies.HistoryOrderServiceProxy,
        ApiServiceProxies.CategoryMobileServiceProxy,
        ApiServiceProxies.OrderDetailPublicServiceProxy,
        ApiServiceProxies.UserOtpServiceProxy,
        ApiServiceProxies.TransactionPublicServiceProxy,
        ApiServiceProxies.ReportServiceProxy,
        ApiServiceProxies.PersonRelativeServiceProxy,
        ApiServiceProxies.CatalogServiceProxy,
        ApiServiceProxies.ContractServiceProxy,
        ApiServiceProxies.ConfigServiceProxy,
        ApiServiceProxies.OrderPaymentServiceProxy,
        ApiServiceProxies.AgencyServiceProxy,
        ApiServiceProxies.InvestorServiceProxy,
        ApiServiceProxies.WalletServiceProxy,
        ApiServiceProxies.WalletHistoryServiceProxy,
        ApiServiceProxies.PostLeaseManagementServiceProxy,
        ApiServiceProxies.InvestorDetailServiceProxy,
        ApiServiceProxies.WithdrawServiceProxy,
        ApiServiceProxies.BankServiceProxy,
        ApiServiceProxies.FileMangerServiceProxy,
        ApiServiceProxies.TransactionDetailServiceProxy,
        ApiServiceProxies.UserOrderSplittingServiceProxy,
        ApiServiceProxies.ManagerAgencyServiceProxy,
        ApiServiceProxies.AgencyHistoryServiceProxy,
        ApiServiceProxies.InvestorHistoryServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
